import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Col, Row } from 'react-bootstrap';

const HomePage = () => {

    const company = JSON.parse(localStorage.getItem("Company"));
    useEffect(() => {
        document.body.classList = "mainPage";
    }, []);
    return (
        <div>
            <div className='mainPageTopDiv' >
                <img src={company?.CompanyLogo} className='mainPageLogo' />
            </div>
            <Row>
                <div className={window.innerWidth > 414 ? "menuContainer col-md-6" : "menuContainer"}>
                    <div className="page-container row ">
                        <div className="col-4 navigate-item">
                            <Link to="/service">
                                <img src={process.env.PUBLIC_URL + "/images/AddRequest.png"} />
                                <p> ثبت درخواست </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/tasks">
                                <img src={process.env.PUBLIC_URL + "/images/RequestList.png"} />

                                <p>  درخواستهای من </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/Happycall/0/''">
                                <img src={process.env.PUBLIC_URL + "/images/HappyCall.png"} />
                                <p>   رضایت سنجی </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/GuaranteecardStatus">
                                <img src={process.env.PUBLIC_URL + "/images/Inquiry.png"} />
                                <p>    استعلام سریال </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/Complaint/0/''/0/0/0">
                                <img src={process.env.PUBLIC_URL + "/images/Complaint.png"} />
                                <p>   ثبت شکایت </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/ComplaintList">
                                <img src={process.env.PUBLIC_URL + "/images/ComplaintList.png"} />
                                <p>   پیگیری شکایات </p>
                            </Link>
                        </div>
                        <div className="col-4 navigate-item">
                            <Link to="/Ticket">
                                <img src={process.env.PUBLIC_URL + "/images/SupportTicket.png"} />
                                <p>   تیکت پشتیبانی </p>
                            </Link>
                        </div> 
                        <div className="col-4 navigate-item">
                            <Link to="/NoticeBoard">
                                <img src={process.env.PUBLIC_URL + "/images/NoticeBoard.png"} />
                                <p>   اطلاعیه ها </p>
                            </Link>
                        </div>    
                        <div className="col-4 navigate-item">
                            <Link to="/CustomerProducts">
                                <img src={process.env.PUBLIC_URL + "/images/ProductRequest.png"} />
                                <p>   محصولات درخواستی </p>
                            </Link>
                        </div>                                                                    
                    </div> 
                    </div>
                {window.innerWidth > 414 &&
                    <Col md={6} className='mainPageBGImageContainer'>
                        <img src={process.env.PUBLIC_URL + "/images/MainPageBackground.png"} className='mainPageBGImage'/>
                    </Col>
                }

            </Row>

        </div>

    )

}

export default HomePage;